// src/config/moves.ts — MoveDef tablosu (TAM): silahsız 15 (+ koşu Kick ve kalkış Kick varyantları) + 1H 8 + 2H 6 + dual 7 + asa 6 + kalkan bash.
// WP0 şeması + örnekleri (L1, H1, H2, D1, G2) korunmuş; WP3 kalanını aynı şemayla doldurdu. Sayılar DESIGN §4.1/§4.2 birebir;
// klip/tS/clipStart ANIMATION §2.2/§2.3 (clipStart = impact − w·DT·tS; data/clipdata.json impact'leriyle types.test doğrular).
// Klip adları YALNIZ CLIPS'ten; clipIdx yükleme sonunda ClipDataSet.indexOf ile çözülür (−1 = çözülmedi; hitbox.ts tembel çözer).
// Testler hamleyi `id` ile bulur (tablo dolunca indeks kayar).
//
// WP3 kararları (DESIGN'da belirsiz noktalar; dönüş raporunda "deviations"):
//  • Koşarken Y = `H1_kick_run` (H1 birebir + keepMomentum "Kick (momentumla)"), holdBranch D2 — H1'in holdBranch'i Sweep olduğundan koşu
//    bağlamı ayrı MoveDef ister (ıska takibinde bağlam Kick BAŞINDAKİ bağlamdır; dallanma anında hız çoktan düşmüş olabilir).
//  • 1H WR-Y = D2'nin silahlı kopyası (`W1H_leap_smash`, uç r 0.6); koşu Kick'inden dallanma silaha göre `HOLD_BRANCH_BY_WEAPON` ile.
//  • Silahlı hava X'ler ve dual hava Y: clipdata ölçümünde Slice_Horizontal 72.6°, 2H_Slice 100.5°, Dualwield_Chop 31.2° hipsYawRange
//    > 25° → `#upper` türevi ÜRETİLMEZ (ANIMATION §4 kapısı, clipData.ts) → hepsi DESIGN'ın dual hava X kuralıyla `Punch_A#upper`
//    (A1 verisi, sınıf dmg çarpanı tabloya işlendi: 1H 4, 2H 5, asa 2, dual 4).
//  • Dual WH aşama 2 tS 1.8 → 1.4: 23 t (a+r) × 1.8/60 = 0.69 s, dilim [0.53–1.10] yalnız 0.57 s → klip süresi kuralı 4 t ihlal ediyordu.
//  • Asa WR-Y: Spinning 1 tur DOĞRUDAN (Kick aşaması yok; DESIGN "Y basılı → silah özel yalnız asa WH2" kuralıyla tutarlı), w 9 (heavy kuralı).
//  • Asa WH2 "koni 30°, menzil 4 u": mermi yok → center hitbox (ileri 2.0, yukarı 1.0) r 2.0 + koni 30° (0–4 u kapsar).
//  • G3 / K (kalkış tekmesi): stages; K'nin 2. aşaması H1_kick_getup değerleriyle (H1 birebir, kb 8) — ayrı MoveDef de var (MOVE_ID.H1_GETUP).
//  • Kök hareket aşamalı hamlede: `scaled` → stages[0] (Dual WH Dodge_Forward), `extract` → son aşama (D2 Jump_Chop) — sim/moves.ts rmStageOf.
//
// SES (kullanıcı geri bildirimi, DESIGN §11 güncellendi): `sfxWindup: 'whoosh_light'` TÜM hamlelerden KALDIRILDI. NEDEN: hafif
// hamleler en sık kullanılanlar ve savurma sesi ıskada da çalıyordu — sürekli "vuuş" gürültüsü isabet seslerini bastırıyor,
// dövüş okunmaz oluyordu ("bosa yumruk sallarken cikan ruzgar sesi kalksin ... vurunca cikan sesi duyamiyorum bile").
// `whoosh_heavy` KALDI: DESIGN §4/§12 kuralı gereği ağır hamlenin tell'i (active'ten ≥ 150 ms önce) hem oyuncunun hem botun
// tehdit algısının dayanağı; kaldırmak adaleti bozardı. Bunun yerine yalnız KAZANCI kısıldı (view/audio.ts SOUND_GAIN).
import { Body, Btn } from '../core/types.ts';
import type { HitboxDef, MoveDef, MoveStage, WeaponKind } from '../core/types.ts';
import { CLIPS, parseClipName } from './clipTable.ts';
import { T } from './tuning.ts';

/** Kanonik hamle id'leri (WP3 aynı adları kullanır; iptal `next` / `holdBranch` hedefleri bu sabitlerle yazılır). */
export const MOVE_ID = {
  L1: 'L1_jab', L2: 'L2_cross', L3: 'L3_hook',
  H1: 'H1_kick', H2: 'H2_sweep', H1_GETUP: 'H1_kick_getup', H1_RUN: 'H1_kick_run',
  A1: 'A1_air_jab', A2: 'A2_flying_kick',
  D1: 'D1_dash_tackle', D2: 'D2_leap_smash',
  G1: 'G1_grab', G2: 'G2_throw', G3: 'G3_pickup',
  C_BASH: 'C_shoulder_bash', T: 'T_taunt', GETUP_KICK: 'K_getup_kick', SHIELD_BASH: 'S_shield_bash',
  // 1H (DESIGN §4.2): W1 W2 W3 WH · WR-X (W2 + momentum) · WR-Y (D2 silahlı) · WA-Y (Dive Chop) · hava X
  W1H_1: 'W1H_slice_h', W1H_2: 'W1H_slice_d', W1H_3: 'W1H_chop', W1H_H: 'W1H_stab',
  W1H_RX: 'W1H_run_slice', W1H_RY: 'W1H_leap_smash', W1H_AY: 'W1H_dive_chop', W1H_AX: 'W1H_air_x',
  // 2H: W1 W2 WH Spin · WR-X (Stab) · WR-Y (Spin + momentum) · hava X
  W2H_1: 'W2H_slice', W2H_2: 'W2H_chop', W2H_H: 'W2H_spin', W2H_RX: 'W2H_run_stab', W2H_RY: 'W2H_run_spin', W2H_AX: 'W2H_air_x',
  // Dual: W1 W2 W3 W4 · WH Dash Stab · WA-Y · hava X (WR-X/WR-Y = W1/WH)
  WD_1: 'WD_slice', WD_2: 'WD_chop', WD_3: 'WD_slice_m', WD_4: 'WD_stab', WD_H: 'WD_dash_stab', WD_AY: 'WD_air_y', WD_AX: 'WD_air_x',
  // Asa: W1 W2 · WH Stab · WH2 itki · WR-Y Spinning · hava X (WR-X = WH Stab)
  WS_1: 'WS_slice', WS_2: 'WS_slice_m', WS_H: 'WS_stab', WS_H2: 'WS_push_wave', WS_RY: 'WS_run_spin', WS_AX: 'WS_air_x',
} as const;

/** Eklem hitbox'ı kısayolu: pencere [from, to] dahil (from = w, to = w + a − 1). */
const hb = (joint: HitboxDef['joint'], radius: number, from: number, to: number, extra: Partial<HitboxDef> = {}): HitboxDef =>
  ({ joint, radius, from, to, ...extra });

/** Kick aşaması (H2/D2 stages[0]): H1 tam, 0–14 t; ıska takibinde 15. t'de ikinci aşamaya geçilir (moveTick korunur). */
const KICK_STAGE: MoveStage = { clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4, ticks: 15, fade: T.ANIM.fadeAttackIn };
/** Asa WH Stab aşaması (WH2 stages[0]): 2H_Stab tam, 0–14 t. */
const STAFF_STAB_STAGE: MoveStage = { clip: CLIPS.STAB_2H, clipIdx: -1, clipStart: 0.50, clipRate: 1.8, ticks: 15, fade: T.ANIM.fadeAttackIn };

// ── Ortak iptal listeleri ──
/** Silahlı hafif seri adımı: r+1 → sonraki (dokunduysa), dodge; r+3 → zıpla/blok. DESIGN §4 "seri sıfırlanır" → `next` onTouch. */
const seriesCancels = (next: string, heavyToo: boolean) => {
  const c: MoveDef['cancels'] = [
    { at: 1, rel: 'recover', into: 'next', next, onTouch: true },
    { at: 1, rel: 'recover', into: 'dodge' },
    { at: 3, rel: 'recover', into: 'jump' },
    { at: 3, rel: 'recover', into: 'block' },
  ];
  if (heavyToo) c.push({ at: 1, rel: 'recover', into: 'heavy', onTouch: true });
  return c;
};
/** Bitirici / ağır: isabette r+6 → dodge, r+10 → X (yeni seri) (H1 kuralı). */
const heavyCancels: MoveDef['cancels'] = [
  { at: 6, rel: 'recover', into: 'dodge', onTouch: true },
  { at: 10, rel: 'recover', into: 'light', onTouch: true },
];
const LOCK_HEAVY = { family: 'heavy' as const, ticks: T.COMBAT.lockAfterHeavy };

// ── H1 Kick tabanı (H1 / H1_kick_run / H1_kick_getup / K stage 2 paylaşır) ──
const KICK_BASE = {
  family: 'heavy' as const, weapon: 'unarmed' as const, trigger: Btn.Heavy,
  clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4,
  windup: 9, active: 6, recover: 17, whiffRecoverMult: 1.4,   // 9/6/17; ıska r 24 t; bilinen 2 t klip aşımı (0.967 > 0.933) kabul
  dmg: 8, stun: 38, kb: 7, lift: 3, hitstop: T.HITSTOP.heavy,
  heavy: true, hitsLying: true, guardCost: T.BLOCK.guardCostHeavy,
  rootMotion: { mode: 'none' } as const, selfPush: 1.2,   // bastır / selfPush 1.2 (klip ±0.07 ihmal)
  lockAfter: LOCK_HEAVY,
  sfxWindup: 'whoosh_heavy',   // w ≥ 9: active'ten ≥ 150 ms önce
};

/** Silahlı hava X / dual hava Y için Punch_A#upper (A1 verisi) — bkz. dosya başı kararı. */
const airPunch = (id: string, weapon: WeaponKind, dmg: number, stun: number, kb: number, lift: number): MoveDef => ({
  id, family: 'air', weapon, body: Body.Air, trigger: Btn.Light,
  clip: CLIPS.PUNCH_A_UPPER, clipIdx: -1, clipStart: 0.333, clipRate: 2.0, upperOnly: true,
  windup: 5, active: 5, recover: 10, whiffRecoverMult: 1.0, landPhase: 'recover',   // inişte biter + JUMP.landTicks 8 t kilit
  hitboxes: [hb('hand.r', 0.55, 5, 9)],
  dmg, stun, kb, lift, hitstop: T.HITSTOP.light,
  heavy: false, guardCost: T.BLOCK.guardCostLight,
  rootMotion: { mode: 'none' }, selfPush: 0,
  cancels: [], usesPerAir: 2,
});

/** Silahlı hafif seri adımı (uç + orta, aynı grup). */
const weaponHb = (rTip: number, rMid: number, from: number, to: number, extra: Partial<HitboxDef> = {}): HitboxDef[] =>
  [hb('weapon.tip', rTip, from, to, extra), hb('weapon.mid', rMid, from, to, extra)];

export const MOVES: MoveDef[] = [
  // ═══════════════════════════════ 4.1 Silahsız ═══════════════════════════════
  // ── L1 Jab — DESIGN §4.1: Punch_A · tS 2.0 · clipStart 0.333 · impact hand.r 0.50 s (ölçüm; reach 0.98, h 0.89) ──
  {
    id: MOVE_ID.L1, family: 'light', weapon: 'unarmed', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.PUNCH_A, clipIdx: -1, clipStart: 0.333, clipRate: 2.0,
    windup: 5, active: 4, recover: 12, whiffRecoverMult: 1.0,   // 5/4/12; hafifte whiff cezası yok, seri sıfırlanır
    hitboxes: [hb('hand.r', 0.55, 5, 8)],
    dmg: 3, stun: 18, kb: 4.5, lift: 1.0, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    // çıkar ×0.5, pencere [0.33–0.62] (hips −0.18 → +0.35 = +0.53 u ölçüm → 0.27 u); pencere başı ≥ clipStart − 1 kare ✓; selfPush 0 (çift sayım yok)
    rootMotion: { mode: 'extract', window: [0.33, 0.62], mult: 0.5 }, selfPush: 0,
    cancels: [
      { at: 2, rel: 'hit', into: 'next', next: MOVE_ID.L2 },           // hit+2 → L2 (dokunduysa)
      { at: 2, rel: 'hit', into: 'dodge' },                            // hit+2 → dodge
      { at: 1, rel: 'recover', into: 'next', next: MOVE_ID.L2, onTouch: true },   // r+1 → L2 (blokta dokunduysa)
      { at: 1, rel: 'recover', into: 'dodge' },                        // r+1 → dodge
      { at: 3, rel: 'recover', into: 'jump' },                         // r+3 → zıpla
      { at: 3, rel: 'recover', into: 'block' },                        // r+3 → blok
    ],
  },
  // ── L2 Cross — DESIGN §4.1: Punch_A~ (aynalı) · tS 1.9 · clipStart 0.31 · impact 0.50 s · hand.l ──
  {
    id: MOVE_ID.L2, family: 'light', weapon: 'unarmed', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.PUNCH_A_M, clipIdx: -1, clipStart: 0.31, clipRate: 1.9,
    windup: 6, active: 4, recover: 13, whiffRecoverMult: 1.0,
    hitboxes: [hb('hand.l', 0.55, 6, 9)],
    dmg: 4, stun: 24, kb: 6, lift: 1.5, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'extract', window: [0.31, 0.62], mult: 0.7 }, selfPush: 0,   // çıkar ×0.7 (0.37 u); selfPush 0
    cancels: [
      { at: 2, rel: 'hit', into: 'next', next: MOVE_ID.L3 },   // hit+2 → L3, Y (Kick), B (tut), dodge
      { at: 2, rel: 'hit', into: 'heavy' },
      { at: 2, rel: 'hit', into: 'grab' },
      { at: 2, rel: 'hit', into: 'dodge' },
      { at: 1, rel: 'recover', into: 'next', next: MOVE_ID.L3, onTouch: true },   // r+1 aynı (blok)
      { at: 1, rel: 'recover', into: 'heavy', onTouch: true },
      { at: 1, rel: 'recover', into: 'grab', onTouch: true },
      { at: 1, rel: 'recover', into: 'dodge' },
      { at: 3, rel: 'recover', into: 'jump' },
    ],
  },
  // ── L3 Hook (kaldırıcı) — DESIGN §4.1: Punch_A · tS 1.5 · clipStart 0.325 · 0.50 s; w 7 (cross→hook payı 3 t) ──
  {
    id: MOVE_ID.L3, family: 'light', weapon: 'unarmed', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.PUNCH_A, clipIdx: -1, clipStart: 0.325, clipRate: 1.5,
    windup: 7, active: 6, recover: 19, whiffRecoverMult: 1.0,   // ıska: tam r; seri biter
    hitboxes: [hb('hand.r', 0.60, 7, 12)],
    // deviation: kb 6.5 (DESIGN §4.1 hook kb 7.5) — X·X·X·Y menzil kabulü (orkestratör kararı 5): 7.5 ile Kick yalnız ≤ 1.1 u başlangıçta
    // yetişiyordu, 6.5 ile 1.0–1.3 u. Yan etki (DESIGN §5 tablosu): hook kbSpeed 5.4 → 4.7 (hitstun 14 → 13 t, kanıt 13 > 11 tutar);
    // hook %100'de 10.3 → 8.9 < 9 → "hook %75+ tumble" notu ≈ %103'e kayar. selfPush yolu Attack sürtünmesi (55 u/s²) yüzünden etkisiz.
    dmg: 7, stun: 40, kb: 6.5, lift: 6, hitstop: T.HITSTOP.heavy,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'extract', window: [0.325, 0.62], mult: 1.5 }, selfPush: 0,   // çıkar ×1.5 (0.80 u); selfPush 0
    cancels: [
      { at: 2, rel: 'hit', into: 'heavy' },   // hit+2 → Y (Kick), B (tut), dodge
      { at: 2, rel: 'hit', into: 'grab' },
      { at: 2, rel: 'hit', into: 'dodge' },
      { at: 9, rel: 'recover', into: 'dodge' },   // r+9 → dodge
    ],
    lockAfter: { family: 'light', ticks: T.COMBAT.lockAfterL3 },   // sonra 24 t X kilidi
  },
  // ── H1 Kick — DESIGN §4.1: Kick · tS 1.4 · clipStart 0.22 · impact toes.r 0.43 s (ölçüm; reach 0.60, h 0.53). heavy, hitsLying ──
  {
    ...KICK_BASE,
    id: MOVE_ID.H1, body: Body.Ground | Body.Running,
    holdBranch: MOVE_ID.H2,   // ıska takibi: 15. t'de dokunmadıysa ∧ Y basılı → Sweep (koşarken Leap: H1_kick_run → D2)
    hitboxes: [hb('toes.r', 0.55, 9, 14)],
    cancels: heavyCancels,   // isabette r+6 → dodge, r+10 → X (yeni seri)
  },
  // ── H1 Kick (koşarken) — DESIGN §2 "Kick (momentumla)": H1 birebir + keepMomentum; ıska takibi → D2 Leap Smash (1H'da W1H_leap_smash) ──
  {
    ...KICK_BASE,
    id: MOVE_ID.H1_RUN, body: Body.Running,
    holdBranch: MOVE_ID.D2,
    hitboxes: [hb('toes.r', 0.55, 9, 14)],
    keepMomentum: true,
    cancels: heavyCancels,
  },
  // ── H1 Kick (kalkış tekmesi 2. aşaması) — DESIGN §4.1: H1 birebir, yalnız kb 8 (lift 3 aynı); dallanma yok ──
  {
    ...KICK_BASE,
    id: MOVE_ID.H1_GETUP, body: Body.Lying,
    hitboxes: [hb('toes.r', 0.55, 9, 14)],
    kb: 8,
    cancels: [],
  },
  // ── H2 Sweep — DESIGN §4.1: stages [Kick 0–14 t (H1 tam)] → [Spinning · tS 1.3 · clipStart 0 · loop, 15. t'den, 0.04 fade] ──
  // Yalnız H1'in holdBranch hedefi olarak girilir (moveTick 15 ile; tetik tablosunda yok). w 19 = 15 Kick + 4 Spinning giriş.
  {
    id: MOVE_ID.H2, family: 'heavy', weapon: 'unarmed', body: Body.Ground | Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4,   // ilk aşamayla aynı (şema kuralı)
    stages: [
      KICK_STAGE,
      { clip: CLIPS.SPINNING, clipIdx: -1, clipStart: 0, clipRate: 1.3, ticks: -1, fade: T.ANIM.fadeStage, loop: true },   // hips yaw 360°/0.667 s, root dönmez
    ],
    windup: 19, active: 31, recover: 21, whiffRecoverMult: 1.4,   // 19/31/21; 1 tur, pencere 19–49; ıska r 29 t
    hitboxes: [hb('hand.r', 0.55, 19, 49), hb('hand.l', 0.55, 19, 49)],   // iki el TEK grup (0): her hedefe 1×; eller y 0.93 → yatana vurmaz
    dmg: 9, stun: 45, kb: 8, lift: 5, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: 40,   // §3 Sweep guard −40
    rootMotion: { mode: 'none' }, selfPush: 0,   // bastır (klip 0.15 u yarıçaplı daire)
    cancels: [],
    lockAfter: LOCK_HEAVY,
    sfxWindup: 'whoosh_heavy',   // holdBranch geçişinde TEKRAR ÇALMAZ (Ev.MoveStart hedef için; ARCHITECTURE §2)
  },
  // ── A1 Air Jab — DESIGN §4.1: Punch_A#upper · 2.0 · 0.333; alt Jump_Idle#lower; 5/5/10 landPhase recover; yatay hız ×0.6; 2×/hava ──
  {
    id: MOVE_ID.A1, family: 'air', weapon: 'unarmed', body: Body.Air, trigger: Btn.Light,
    clip: CLIPS.PUNCH_A_UPPER, clipIdx: -1, clipStart: 0.333, clipRate: 2.0, upperOnly: true,
    windup: 5, active: 5, recover: 10, whiffRecoverMult: 1.0, landPhase: 'recover',
    hitboxes: [hb('hand.r', 0.55, 5, 9)],
    dmg: 3, stun: 16, kb: 4.5, lift: 2.5, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: [], usesPerAir: 2,
  },
  // ── A2 Flying Kick — DESIGN §4.1: Kick@0.25-0.50 · 1.6 · clipStart 0.25 · pause 0.50 (kanonik) · root pitch +12°; 9 / ≤20 (landPhase active) / 10 ──
  {
    id: MOVE_ID.A2, family: 'air', weapon: 'unarmed', body: Body.Air, trigger: Btn.Heavy,
    clip: CLIPS.KICK_FLY, clipIdx: -1, clipStart: 0.25, clipRate: 1.6, pauseAt: 0.50, rootPitch: 12,
    windup: 9, active: 20, recover: 10, whiffRecoverMult: 1.4, landPhase: 'active',
    hitboxes: [hb('toes.r', 0.65, 9, 28)],
    dmg: 10, stun: 45, kb: 9, lift: 4, hitstop: T.HITSTOP.finisher,
    heavy: true, hitsLying: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 9, selfPushVy: -2,   // bastır / 9 ileri, vy −2 (isabette −3 geri seker: sim/moves.ts)
    cancels: [], onWhiff: 'faceplant',   // active isabetsiz biterse Death_B 13 t → LyingFront 24 t → otomatik hızlı kalk 28 t, sonrası i-frame 0
    lockAfter: LOCK_HEAVY,
    sfxWindup: 'whoosh_heavy',
  },
  // ── D1 Dash Tackle — DESIGN §4.1: X koşarken; Melee_Block_Attack · tS 1.5 · clipStart 0.295 · hand.l 0.47 s (sol kol öne) ──
  {
    id: MOVE_ID.D1, family: 'dash', weapon: 'unarmed', body: Body.Running, trigger: Btn.Light,
    clip: CLIPS.BLOCK_ATTACK, clipIdx: -1, clipStart: 0.295, clipRate: 1.5,
    windup: 7, active: 8, recover: 17, whiffRecoverMult: 1.4,   // 7/8/17; ıska r 24 t (klip kuralı dışı: 1.27 > 1.07)
    hitboxes: [hb('center', 0.75, 7, 14, { offset: [0.85, 1.1, 0] })],   // center (ileri 0.85, yukarı 1.1, yan 0) r 0.75
    dmg: 6, stun: 34, kb: 6.5, lift: 2.5, hitstop: T.HITSTOP.heavy,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    // ölçekle: hips [0.30–0.47] (−0.13 → +0.17 = 0.30 u ölçüm) ×4.0 = 1.2 u; yön = hamle başındaki bakış (WP3 dodgeDirX/Z'ye yazar);
    // koşu hızı korunur (keepMomentum, vel yoluyla) — ikisi de kenar frenine tabi; selfPush 0
    rootMotion: { mode: 'scaled', window: [0.30, 0.47], distance: 1.2 }, selfPush: 0, keepMomentum: true,
    cancels: [{ at: 3, rel: 'recover', into: 'next', next: MOVE_ID.L2, onTouch: true }],   // isabette r+3 → X = L2 (seri cross'tan başlar)
    // bloklanırsa saldıran Hit_A 0.30 s (hits.ts: Blocked + family 'dash' → saldırana GRAB.grabbedHolderStunTicks 18 t Hitstun)
  },
  // ── D2 Leap Smash — DESIGN §4.1: stages [Kick 0–14 t] → [Jump_Chop · 1.4 · 0.377, 15. t'den, 0.06 fade]; hand.r 0.75 s = 15 + 16 t ──
  // Yalnız koşu Kick'inin (H1_kick_run) holdBranch hedefi. Süper zırh 15–31 t; şok halkası impact tick'inde yalnız yerdekilere.
  {
    id: MOVE_ID.D2, family: 'heavy', weapon: 'unarmed', body: Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4,
    stages: [
      KICK_STAGE,
      { clip: CLIPS.JUMP_CHOP, clipIdx: -1, clipStart: 0.377, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStageG3 },   // çömelme atlanır
    ],
    windup: 31, active: 6, recover: 21, whiffRecoverMult: 1.4,   // 31 (15 + 16) / 6 / 21; ıska r 29 t; bilinen 3 t klip aşımı (1.38 > 1.333) kabul
    hitboxes: [
      hb('hand.r', 0.70, 31, 36),
      hb('center', 1.6, 31, 31, { offset: [0.9, 0.3, 0], groundedOnly: true, hitsLying: true, override: { dmg: 4, stun: 15, kb: 6, lift: 2 } }),   // halka; ana elle aynı grup
    ],
    dmg: 10, stun: 50, kb: 10, lift: 6, hitstop: T.HITSTOP.finisher,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'extract', window: [0.38, 0.80], mult: 1.5 }, selfPush: 0, keepMomentum: true,   // Jump_Chop aşamasında (rmStageOf: son aşama)
    armor: [15, 31],   // kb ×0.3, kesilmez; knockdown kuralı zırh altında da tetiklenir (DESIGN §5)
    cancels: [],
    lockAfter: LOCK_HEAVY,
    sfxWindup: 'whoosh_heavy',
  },
  // ── G1 Grab — DESIGN §4.1: Interact tam klip · 1.5 · 0.345 · el 0.57 s; 9/6/18; center (0, 1.0, 0.8) r 0.70; bloğu yener ──
  {
    id: MOVE_ID.G1, family: 'grab', weapon: 'unarmed', body: Body.Ground | Body.Running, trigger: Btn.Grab,
    clip: CLIPS.INTERACT, clipIdx: -1, clipStart: 0.345, clipRate: 1.5,
    windup: 9, active: 6, recover: 18, whiffRecoverMult: 1.0,   // ıska: tam r 18 (0.30 s açık, donuk poz yok)
    hitboxes: [hb('center', 0.70, 9, 14, { offset: [0.8, 1.0, 0] })],
    dmg: 0, stun: 0, kb: 0, lift: 0, hitstop: 0,
    heavy: false, unblockable: true, guardCost: 0,
    rootMotion: { mode: 'none' }, selfPush: 0.8,
    cancels: [],
    sfxWindup: 'grab_grip',
  },
  // ── G2 Throw — DESIGN §4.1: B (Hold ya da Carry); Throw · tS 1.5 · clipStart 0.20 · bırakma 0.67 s (el hız tepesi, ölçüm) ──
  // Tetik bağlam tablosundan değil grab.ts'den (Hold 15 t kilidi / Carry'de B). Hitbox yok: fırlatılan beden mermidir (r 0.6, grab.ts).
  {
    id: MOVE_ID.G2, family: 'grab', weapon: 'unarmed', body: Body.Ground | Body.Carrying, trigger: Btn.Grab,
    clip: CLIPS.THROW, clipIdx: -1, clipStart: 0.20, clipRate: 1.5,
    windup: T.GRAB.throwReleaseTick, active: 1, recover: 15, whiffRecoverMult: 1.0,   // 19 / bırakma tick'i / 15 (sonra hareket)
    hitboxes: [],
    dmg: T.GRAB.throwDmg, stun: 0, kb: T.GRAB.throwKb, lift: T.GRAB.throwLift, hitstop: T.HITSTOP.finisher,   // fırlatılan 12 / — · 6.5 / 5 (%-ölçekli, tumble tavanı)
    heavy: true, knockdown: true, unblockable: true, guardCost: 0,
    rootMotion: { mode: 'none' }, selfPush: 0,   // bastır (klip ±0.12)
    cancels: [],
    sfxWindup: 'throw_yell',
  },
  // ── G3 Pick Up — DESIGN §4.1: stages [PickUp@0.15-0.70 · 1.4, 0–15 t] → kavrama 16. t → [PickUp@0.70-1.20 · 1.4, 16–37 t, 0.06 fade] → Carry ──
  {
    id: MOVE_ID.G3, family: 'grab', weapon: 'unarmed', body: Body.Ground, trigger: Btn.Grab,
    clip: CLIPS.PICKUP_GRIP, clipIdx: -1, clipStart: 0.15, clipRate: 1.4,
    stages: [
      { clip: CLIPS.PICKUP_GRIP, clipIdx: -1, clipStart: 0.15, clipRate: 1.4, ticks: T.GRAB.pickUpGripTick, fade: T.ANIM.fadeAttackIn },
      { clip: CLIPS.PICKUP_RAISE, clipIdx: -1, clipStart: 0.70, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStageG3 },
    ],
    windup: T.GRAB.pickUpGripTick, active: 0, recover: T.GRAB.pickUpTotal - T.GRAB.pickUpGripTick, whiffRecoverMult: 1.0,   // 16 / — / 22; temas (hitbox yok)
    hitboxes: [],
    dmg: 0, stun: 0, kb: 0, lift: 0, hitstop: 0,
    heavy: false, unblockable: true, guardCost: 0,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: [],   // ilk 16 t'de vurulursa iptal (hits.ts → grab.ts)
    sfxWindup: 'grab_grip',
  },
  // ── C Omuz çarpması — DESIGN §4.1 C: Carry'de Y; D1 tanımı, kb 8 (9 tumble eşiğiydi); isabette kurban düşer (Lying 48 t) ──
  {
    id: MOVE_ID.C_BASH, family: 'carry', weapon: 'unarmed', body: Body.Carrying, trigger: Btn.Heavy,
    clip: CLIPS.BLOCK_ATTACK, clipIdx: -1, clipStart: 0.295, clipRate: 1.5,
    windup: 7, active: 8, recover: 17, whiffRecoverMult: 1.0,
    hitboxes: [hb('center', 0.75, 7, 14, { offset: [0.85, 1.1, 0] })],
    dmg: 6, stun: 34, kb: 8, lift: 2.5, hitstop: T.HITSTOP.heavy,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'scaled', window: [0.30, 0.47], distance: 1.2 }, selfPush: 0,
    cancels: [],
  },
  // ── T Taunt — DESIGN §4.1: Cheering tS 1.2 (83 t); karakter klibi characters.ts'den (animMap); 9 t'den sonra iptal; stun −40/s ──
  {
    id: MOVE_ID.T, family: 'taunt', weapon: 'any', body: Body.Ground, trigger: Btn.Taunt,
    clip: CLIPS.CHEERING, clipIdx: -1, clipStart: 0, clipRate: T.ANIM.tauntRate,
    windup: 0, active: 0, recover: T.TAUNT.ticks, whiffRecoverMult: 1.0,
    hitboxes: [],
    dmg: 0, stun: 0, kb: 0, lift: 0, hitstop: 0,
    heavy: false, guardCost: 0,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: [
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'move' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'light' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'heavy' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'grab' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'dodge' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'jump' },
      { at: T.TAUNT.cancelAfterTicks, rel: 'start', into: 'block' },
    ],
    sfxWindup: 'taunt_laugh',
  },
  // ── K Kalkış tekmesi — DESIGN §4.1: stages [Lie_StandUp@1.60-2.33 tS 2.0, 0–21 t (i-frame vuruş + kaldırma)] → [Kick = H1_kick_getup, 22. t'den] ──
  {
    id: MOVE_ID.GETUP_KICK, family: 'lying', weapon: 'unarmed', body: Body.Lying, trigger: Btn.Heavy,
    clip: CLIPS.LIE_STANDUP_QUICK, clipIdx: -1, clipStart: 1.60, clipRate: T.ANIM.getUpKickRate,
    stages: [
      { clip: CLIPS.LIE_STANDUP_QUICK, clipIdx: -1, clipStart: 1.60, clipRate: T.ANIM.getUpKickRate, ticks: T.KNOCKDOWN.getUpKickTicks, fade: T.ANIM.fadeAttackIn },
      { clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStage },
    ],
    windup: T.KNOCKDOWN.getUpKickTicks + 9, active: 6, recover: 17, whiffRecoverMult: 1.4,   // 22 + 9/6/17
    hitboxes: [hb('toes.r', 0.55, T.KNOCKDOWN.getUpKickTicks + 9, T.KNOCKDOWN.getUpKickTicks + 14)],
    dmg: 8, stun: 38, kb: 8, lift: 3, hitstop: T.HITSTOP.heavy,
    heavy: true, hitsLying: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 1.2,
    cancels: [],
    lockAfter: LOCK_HEAVY,
    sfxWindup: 'whoosh_heavy',
  },
  // ── S Kalkan bash — DESIGN §4.2: X blok tutarken (kalkan varsa); Melee_Block_Attack · 1.6 · 0.28 · hand.l 0.47 s; guard maliyeti yok ──
  {
    id: MOVE_ID.SHIELD_BASH, family: 'light', weapon: 'any', body: Body.Blocking, trigger: Btn.Light,
    clip: CLIPS.BLOCK_ATTACK, clipIdx: -1, clipStart: 0.28, clipRate: 1.6,
    windup: 7, active: 6, recover: 16, whiffRecoverMult: 1.0,
    hitboxes: [hb('center', 0.7, 7, 12, { offset: [0.8, 1.0, 0] })],
    dmg: 5, stun: 30, kb: 8, lift: 2, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: [{ at: 1, rel: 'recover', into: 'dodge' }, { at: 3, rel: 'recover', into: 'block' }],
  },

  // ═══════════════════════════════ 4.2 1H (sword_1handed, axe_1handed) — reach +0.4, dmg ×1.3 (tabloda işli) ═══════════════════════════════
  {
    id: MOVE_ID.W1H_1, family: 'weapon', weapon: '1h', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.SLICE_H, clipIdx: -1, clipStart: 0.09, clipRate: 1.8,   // uç 0.27 s (ölçüm), reach 1.15
    windup: 6, active: 5, recover: 14, whiffRecoverMult: 1.0,
    hitboxes: weaponHb(0.6, 0.5, 6, 10),
    dmg: 5, stun: 20, kb: 5, lift: 1.5, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: seriesCancels(MOVE_ID.W1H_2, false),
  },
  {
    id: MOVE_ID.W1H_2, family: 'weapon', weapon: '1h', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.SLICE_D, clipIdx: -1, clipStart: 0.20, clipRate: 1.7,   // uç 0.40 s, reach 1.51
    windup: 7, active: 5, recover: 15, whiffRecoverMult: 1.0,
    hitboxes: weaponHb(0.6, 0.5, 7, 11),
    dmg: 6, stun: 26, kb: 6.5, lift: 2, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'extract', window: [0.30, 0.55], mult: 1.0 }, selfPush: 0,   // −0.25 → +0.17 = 0.42 u (ölçüm)
    cancels: seriesCancels(MOVE_ID.W1H_3, true),
  },
  {
    id: MOVE_ID.W1H_3, family: 'weapon', weapon: '1h', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.CHOP_1H, clipIdx: -1, clipStart: 0.383, clipRate: 1.3,   // downstrike 0.60 s; tS 1.3 ile klip sonu 1.067 = 31 t ✓
    windup: 10, active: 7, recover: 14, whiffRecoverMult: 1.4,
    hitboxes: weaponHb(0.6, 0.5, 10, 16),
    dmg: 9, stun: 42, kb: 8, lift: 4, hitstop: T.HITSTOP.heavy,
    heavy: true, hitsLying: true, guardCost: T.BLOCK.guardCostHeavy,   // bitirici; heavy sayılır; yatana dmg ×0.5
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {
    id: MOVE_ID.W1H_H, family: 'weapon', weapon: '1h', body: Body.Ground, trigger: Btn.Heavy,
    clip: CLIPS.STAB_1H, clipIdx: -1, clipStart: 0.213, clipRate: 1.6,   // uç 0.48 s, reach 1.84
    windup: 10, active: 6, recover: 24, whiffRecoverMult: 1.4,   // ıska r 34 t
    hitboxes: weaponHb(0.5, 0.45, 10, 15, { cone: 40 }),
    dmg: 11, stun: 40, kb: 11, lift: 2, hitstop: T.HITSTOP.heavy,   // kb ≥ 9 → her zaman tumble (tavanlı)
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'extract', window: [0.33, 0.50], mult: 1.0 }, selfPush: 0,   // −0.19 → +0.11 = 0.30 u (ölçüm)
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WR-X: W2 + koşu momentumu; seri W3'e devam
    id: MOVE_ID.W1H_RX, family: 'weapon', weapon: '1h', body: Body.Running, trigger: Btn.Light,
    clip: CLIPS.SLICE_D, clipIdx: -1, clipStart: 0.20, clipRate: 1.7,
    windup: 7, active: 5, recover: 15, whiffRecoverMult: 1.0,
    hitboxes: weaponHb(0.6, 0.5, 7, 11),
    dmg: 6, stun: 26, kb: 6.5, lift: 2, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'extract', window: [0.30, 0.55], mult: 1.0 }, selfPush: 0, keepMomentum: true,
    cancels: seriesCancels(MOVE_ID.W1H_3, true),
  },
  {   // WR-Y: D2 silahlı — koşu Kick'inin ıska takibiyle (HOLD_BRANCH_BY_WEAPON); hitbox uç r 0.6, 12/50, 10/6
    id: MOVE_ID.W1H_RY, family: 'weapon', weapon: '1h', body: Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.KICK, clipIdx: -1, clipStart: 0.22, clipRate: 1.4,
    stages: [
      KICK_STAGE,
      { clip: CLIPS.JUMP_CHOP, clipIdx: -1, clipStart: 0.377, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStageG3 },
    ],
    windup: 31, active: 6, recover: 21, whiffRecoverMult: 1.4,
    hitboxes: [hb('weapon.tip', 0.6, 31, 36)],
    dmg: 12, stun: 50, kb: 10, lift: 6, hitstop: T.HITSTOP.finisher,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'extract', window: [0.38, 0.80], mult: 1.5 }, selfPush: 0, keepMomentum: true,
    armor: [15, 31],
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WA-Y Dive Chop: Jump_Chop@0.55-1.33 · 1.4 · landPhase windup, landSyncTime 0.72, vy −14 dalış; darbe iniş tick'inde; iniş/4/20
    id: MOVE_ID.W1H_AY, family: 'air', weapon: '1h', body: Body.Air, trigger: Btn.Heavy,
    clip: CLIPS.JUMP_CHOP_DIVE, clipIdx: -1, clipStart: 0.55, clipRate: 1.4,
    windup: 9, active: 4, recover: 20, whiffRecoverMult: 1.4, landPhase: 'windup', landSyncTime: 0.72,   // w 9 nominal (heavy kuralı); inişte moveTick = w
    hitboxes: [
      hb('weapon.tip', 0.7, 9, 12),
      hb('center', 1.3, 9, 9, { offset: [0.6, 0.3, 0], groundedOnly: true, hitsLying: true }),   // halka (yerdekiler), ana elle tek grup
    ],
    dmg: 9, stun: 40, kb: 8, lift: 3, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0, selfPushVy: T.JUMP.fastFallVy,   // dalış: vy = min(vy, −14) hamle başında
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  airPunch(MOVE_ID.W1H_AX, '1h', 4, 16, 4.5, 2.5),   // Slice_Horizontal#upper kapıyı geçemez (72.6°) → Punch_A#upper, dmg 3×1.3

  // ═══════════════════════════════ 2H (sword_2handed, axe_2handed) — reach +0.7, dmg ×1.6 (tabloda işli) ═══════════════════════════════
  {
    id: MOVE_ID.W2H_1, family: 'weapon', weapon: '2h', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.SLICE_2H, clipIdx: -1, clipStart: 0.19, clipRate: 1.6,   // uç 0.43 s, reach 1.19
    windup: 9, active: 6, recover: 16, whiffRecoverMult: 1.0,
    hitboxes: weaponHb(0.7, 0.55, 9, 14),
    dmg: 7, stun: 28, kb: 7, lift: 2, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    armor: [3, 9], armorMinStun: 25,   // stun < 25 vuruşlar kesmez
    cancels: seriesCancels(MOVE_ID.W2H_2, false),
  },
  {
    id: MOVE_ID.W2H_2, family: 'weapon', weapon: '2h', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.CHOP_2H, clipIdx: -1, clipStart: 0.53, clipRate: 1.5,   // downstrike 0.83 s
    windup: 12, active: 7, recover: 24, whiffRecoverMult: 1.4,
    hitboxes: weaponHb(0.7, 0.55, 12, 18),
    dmg: 12, stun: 45, kb: 10, lift: 5, hitstop: T.HITSTOP.heavy,
    heavy: true, hitsLying: true, guardCost: 45,   // bitirici, guard −45; kb ≥ 9 → tumble
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {
    id: MOVE_ID.W2H_H, family: 'weapon', weapon: '2h', body: Body.Ground, trigger: Btn.Heavy,
    clip: CLIPS.SPIN_2H_SLICE, clipIdx: -1, clipStart: 0.45, clipRate: 1.8,   // uç geçişleri 0.72 / 1.23 s → tick 9 / 26
    windup: 9, active: 23, recover: 12, whiffRecoverMult: 1.4,   // 9 + 23 + 12 = 44 t ≤ dilim 45 t; ıska r 17
    hitboxes: [
      hb('center', 1.7, 9, 14, { offset: [0, 0.9, 0], cone: 360, group: 0 }),
      hb('center', 1.7, 26, 31, { offset: [0, 0.9, 0], cone: 360, group: 1 }),   // ikinci pencere grup 1: gerçekten iki kez vurur
    ],
    dmg: 12, stun: 45, kb: 12, lift: 4, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0,
    armor: [0, 9],   // zırh w boyunca
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WR-X: 2H_Stab
    id: MOVE_ID.W2H_RX, family: 'weapon', weapon: '2h', body: Body.Running, trigger: Btn.Light,
    clip: CLIPS.STAB_2H, clipIdx: -1, clipStart: 0.52, clipRate: 1.5,   // uç 0.77 s, reach 1.57
    windup: 10, active: 6, recover: 22, whiffRecoverMult: 1.4,
    hitboxes: weaponHb(0.6, 0.5, 10, 15, { cone: 40 }),
    dmg: 10, stun: 36, kb: 10, lift: 2, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0, keepMomentum: true,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WR-Y: WH Spin + momentum
    id: MOVE_ID.W2H_RY, family: 'weapon', weapon: '2h', body: Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.SPIN_2H_SLICE, clipIdx: -1, clipStart: 0.45, clipRate: 1.8,
    windup: 9, active: 23, recover: 12, whiffRecoverMult: 1.4,
    hitboxes: [
      hb('center', 1.7, 9, 14, { offset: [0, 0.9, 0], cone: 360, group: 0 }),
      hb('center', 1.7, 26, 31, { offset: [0, 0.9, 0], cone: 360, group: 1 }),
    ],
    dmg: 12, stun: 45, kb: 12, lift: 4, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0, keepMomentum: true,
    armor: [0, 9],
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  airPunch(MOVE_ID.W2H_AX, '2h', 5, 16, 4.5, 2.5),   // 2H_Slice#upper kapıyı geçemez (100.5°) → Punch_A#upper, dmg 3×1.6

  // ═══════════════════════════════ Dual (dagger ×2) — en hızlı, stun ×1.25 (tabloda işli), 4 adım ═══════════════════════════════
  {
    id: MOVE_ID.WD_1, family: 'weapon', weapon: 'dual', body: Body.Ground | Body.Running, trigger: Btn.Light,
    clip: CLIPS.DUAL_SLICE, clipIdx: -1, clipStart: 0.50, clipRate: 2.0,   // el 0.67 s, uç 0.68
    windup: 5, active: 4, recover: 11, whiffRecoverMult: 1.0,
    hitboxes: [hb('weapon.tip.l', 0.45, 5, 8), hb('weapon.tip', 0.45, 5, 8)],
    dmg: 3, stun: 20, kb: 4, lift: 1, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: seriesCancels(MOVE_ID.WD_2, false),
  },
  {   // W2: iki darbe — sağ uç 0.50 s (grup 0, tick 6–9), sol uç 0.90 s (grup 1, tick 19–22); r 7 → klip sonu 1.267 = tick 30
    id: MOVE_ID.WD_2, family: 'weapon', weapon: 'dual', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.DUAL_CHOP, clipIdx: -1, clipStart: 0.31, clipRate: 1.9,
    windup: 6, active: 17, recover: 7, whiffRecoverMult: 1.0,
    hitboxes: [
      hb('weapon.tip', 0.45, 6, 9, { group: 0 }),
      hb('weapon.tip.l', 0.45, 19, 22, { group: 1, override: { dmg: 3, stun: 16, kb: 5, lift: 2 } }),
    ],
    dmg: 3, stun: 16, kb: 3, lift: 1, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: seriesCancels(MOVE_ID.WD_3, false),
  },
  {
    id: MOVE_ID.WD_3, family: 'weapon', weapon: 'dual', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.DUAL_SLICE_M, clipIdx: -1, clipStart: 0.50, clipRate: 2.0,
    windup: 5, active: 4, recover: 11, whiffRecoverMult: 1.0,
    hitboxes: [hb('weapon.tip', 0.45, 5, 8), hb('weapon.tip.l', 0.45, 5, 8)],
    dmg: 4, stun: 24, kb: 5, lift: 1.5, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: seriesCancels(MOVE_ID.WD_4, false),
  },
  {   // W4 Stab: bitirici, heavy (w 9 whoosh_heavy kuralı); bastır / selfPush 7 (≈ 0.45 u) — ölçüm: atılım clipStart'tan önce
    id: MOVE_ID.WD_4, family: 'weapon', weapon: 'dual', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.DUAL_STAB, clipIdx: -1, clipStart: 0.50, clipRate: 1.8,   // uç 0.77 s, reach 1.74
    windup: 9, active: 5, recover: 18, whiffRecoverMult: 1.4,
    hitboxes: [hb('weapon.tip.l', 0.45, 9, 13), hb('weapon.tip', 0.45, 9, 13)],
    dmg: 7, stun: 36, kb: 7, lift: 3, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 7,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WH Dash Stab: stages [Dodge_Forward tS 1.2 (ölçekle 1.3 u), 0–19 t] → [Dualwield_Stab@0.53-1.10, 20. t'den, 0.04 fade]; 20/5/18
    id: MOVE_ID.WD_H, family: 'weapon', weapon: 'dual', body: Body.Ground | Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.DODGE_F, clipIdx: -1, clipStart: 0, clipRate: 1.2,
    stages: [
      { clip: CLIPS.DODGE_F, clipIdx: -1, clipStart: 0, clipRate: 1.2, ticks: 20, fade: T.ANIM.fadeAttackIn },
      { clip: CLIPS.DUAL_STAB_DASH, clipIdx: -1, clipStart: 0.53, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStage },   // tS 1.8 → 1.4 (dosya başı)
    ],
    windup: 20, active: 5, recover: 18, whiffRecoverMult: 1.4,   // ıska r 25
    hitboxes: [hb('weapon.tip.l', 0.5, 20, 24), hb('weapon.tip', 0.5, 20, 24)],
    dmg: 9, stun: 45, kb: 8, lift: 2, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'scaled', window: [T.DODGE.rmWindow[0], T.DODGE.rmWindow[1]], distance: 1.3 }, selfPush: 0,   // stages[0] (rmStageOf)
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WA-Y: Dualwield_Chop#upper kapıyı geçemez (31.2°) → Punch_A#upper (A1 zamanlaması), dual WA-Y değerleri 4/20 · 5/3
    ...airPunch(MOVE_ID.WD_AY, 'dual', 4, 20, 5, 3), trigger: Btn.Heavy, usesPerAir: undefined,
  },
  airPunch(MOVE_ID.WD_AX, 'dual', 4, 16, 4.5, 2.5),   // DESIGN §4.2: Punch_A#upper (A1 verisi, dmg ×1.3 = 4), 2×/hava

  // ═══════════════════════════════ Asa (staff) — reach 2.0, dmg ×0.8 (tabloda işli), 2 adım ═══════════════════════════════
  {
    id: MOVE_ID.WS_1, family: 'weapon', weapon: 'staff', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.SLICE_2H, clipIdx: -1, clipStart: 0.19, clipRate: 1.8,
    windup: 8, active: 5, recover: 14, whiffRecoverMult: 1.0,
    hitboxes: weaponHb(0.5, 0.45, 8, 12),
    dmg: 4, stun: 22, kb: 6, lift: 1.5, hitstop: T.HITSTOP.light,
    heavy: false, guardCost: T.BLOCK.guardCostLight,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: seriesCancels(MOVE_ID.WS_2, false),
  },
  {   // W2: 2H_Slice~ · 1.8 · 0.16; bitirici (heavy sayılır; w 9)
    id: MOVE_ID.WS_2, family: 'weapon', weapon: 'staff', body: Body.Ground, trigger: Btn.Light,
    clip: CLIPS.SLICE_2H_M, clipIdx: -1, clipStart: 0.16, clipRate: 1.8,
    windup: 9, active: 5, recover: 14, whiffRecoverMult: 1.4,
    hitboxes: weaponHb(0.5, 0.45, 9, 13),
    dmg: 5, stun: 26, kb: 7, lift: 2, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WH Stab: 2H_Stab · 1.8 · 0.50 · uç 0.77 s (reach ≈ 2.0); ıska takibi → WH2
    id: MOVE_ID.WS_H, family: 'weapon', weapon: 'staff', body: Body.Ground | Body.Running, trigger: Btn.Heavy,
    holdBranch: MOVE_ID.WS_H2,
    clip: CLIPS.STAB_2H, clipIdx: -1, clipStart: 0.50, clipRate: 1.8,
    windup: 9, active: 6, recover: 20, whiffRecoverMult: 1.4,   // ıska r 28
    hitboxes: [hb('weapon.tip', 0.5, 9, 14, { cone: 35 })],
    dmg: 8, stun: 30, kb: 12, lift: 3, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: T.BLOCK.guardCostHeavy,
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: heavyCancels, lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  {   // WH2 İtki dalgası: stages [2H_Stab 0.50 tS 1.8, 0–14 t] → [Magic_Shoot · 1.4 · 0.227, 15. t'den, 0.04 fade]; uç 0.32 s = 19. t
    id: MOVE_ID.WS_H2, family: 'weapon', weapon: 'staff', body: Body.Ground | Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.STAB_2H, clipIdx: -1, clipStart: 0.50, clipRate: 1.8,
    stages: [
      STAFF_STAB_STAGE,
      { clip: CLIPS.MAGIC_SHOOT, clipIdx: -1, clipStart: 0.227, clipRate: 1.4, ticks: -1, fade: T.ANIM.fadeStage },
    ],
    windup: 19, active: 3, recover: 20, whiffRecoverMult: 1.4,
    hitboxes: [hb('center', 2.0, 19, 21, { offset: [2.0, 1.0, 0], cone: 30 })],   // koni 30°, menzil 4 u, mermi yok
    dmg: 2, stun: 10, kb: 8, lift: 3, hitstop: T.HITSTOP.light,
    // heavy false (düzeltici tur 2): DESIGN §4.2 heavy etiketi yalnız WH Stab'da; WH2 kimliği "herkesi iter; %0'da Hit_B (tumble değil)"
    // — 2 dmg / 10 stun'luk dalga stun ≥ 55 rakibe knockdown bitirici olmasın, 18 t heavy aile kilidi almasın (guardCost light ile tutarlı).
    heavy: false, guardCost: T.BLOCK.guardCostLight,   // herkesi iter; bloklanır (kb ×0.3)
    rootMotion: { mode: 'none' }, selfPush: 0,
    cancels: [], sfxWindup: 'whoosh_heavy',   // sfxWindup whoosh_heavy kalır (w 19 ≥ 9)
  },
  {   // WR-Y: Spinning 1 tur (H2 tanımı, kb 6 lift 2; hitbox center (0, 0.9, 0) r 1.7, 360° — asa uzunluğu); loop
    id: MOVE_ID.WS_RY, family: 'weapon', weapon: 'staff', body: Body.Running, trigger: Btn.Heavy,
    clip: CLIPS.SPINNING, clipIdx: -1, clipStart: 0, clipRate: 1.3,
    stages: [{ clip: CLIPS.SPINNING, clipIdx: -1, clipStart: 0, clipRate: 1.3, ticks: -1, fade: T.ANIM.fadeAttackIn, loop: true }],
    windup: 9, active: 31, recover: 21, whiffRecoverMult: 1.4,
    hitboxes: [hb('center', 1.7, 9, 39, { offset: [0, 0.9, 0], cone: 360 })],
    dmg: 9, stun: 45, kb: 6, lift: 2, hitstop: T.HITSTOP.heavy,
    heavy: true, guardCost: 40,
    rootMotion: { mode: 'none' }, selfPush: 0, keepMomentum: true,
    cancels: [], lockAfter: LOCK_HEAVY, sfxWindup: 'whoosh_heavy',
  },
  airPunch(MOVE_ID.WS_AX, 'staff', 2, 16, 4.5, 2.5),   // 2H_Slice#upper kapıyı geçemez → Punch_A#upper, dmg 3×0.8
];

/** id → MoveDef (yükleme; sıcak yolda moveIdx kullanılır). Bilinmeyen id hata verir (yazım hatası sessiz kalmasın). */
export function moveById(id: string): MoveDef {
  const m = MOVES.find((x) => x.id === id);
  if (!m) throw new Error(`move not found: ${id}`);
  return m;
}
/** id → indeks (kurulumda bir kez kurulan Map; sıcak yolda closure/doğrusal tarama yok — sim/moves.ts openCancels & tableMove her tick çağırır). */
const MOVE_INDEX: ReadonlyMap<string, number> = new Map(MOVES.map((m, i) => [m.id, i] as const));
export const moveIndexOf = (id: string): number => MOVE_INDEX.get(id) ?? -1;

// Dilimli kliplerde clipEnd'i yükleme anında dilim t1'ine çöz (bir kez): hitbox.ts moveClipTime sıcak yolda parseClipName (tahsis) yapmasın.
// types.test kuralı korunur: (clipEnd ?? t1) ≤ t1 → clipEnd = t1. Dilimsiz klipte clipEnd boş kalır (jointAt zaten kare aralığına kırpar).
// Modül yükünde çalışır: clipTable.ts hiçbir modülü import etmez (döngü yok) → ESM sırası parseClipName'i burada her zaman tanımlı kılar
// (entegrasyon tur 2: HMR'daki tek seferlik ReferenceError, import satırı eklenmeden önceki ara düzenleme durumuydu; yenilemede tekrar etmez).
for (const m of MOVES) {
  if (m.clipEnd === undefined) { const p = parseClipName(m.clip); if (p.slice) m.clipEnd = p.slice[1]; }
  if (m.stages) for (const s of m.stages) { if (s.clipEnd === undefined) { const p = parseClipName(s.clip); if (p.slice) s.clipEnd = p.slice[1]; } }
}

// ───────────────────────────── Bağlam tablosu (DESIGN §2) ─────────────────────────────
/** Tetik bağlamı (sütun): sütun önceliği Taşırken > Yerdeyken(kendisi, knockdown.ts) > Havada > Rakip yerde (yalnız B → G3) > Koşarken > Yerde.
 *  Blok tutarken: X → kalkan varsa S_shield_bash, yoksa yer tablosu (blok bırakılır, guard maliyeti yok). */
export type TriggerContext = 'ground' | 'air' | 'running' | 'carrying';
export interface ContextMoves { light: string; heavy: string; grab: string }   // '' = bu bağlamda hamle yok (silahlıda B = fırlat, items.ts)
const NONE = '';
export const CONTEXT_MOVES: Readonly<Record<TriggerContext, Readonly<Record<WeaponKind, ContextMoves>>>> = {
  ground: {
    unarmed: { light: MOVE_ID.L1, heavy: MOVE_ID.H1, grab: MOVE_ID.G1 },
    '1h': { light: MOVE_ID.W1H_1, heavy: MOVE_ID.W1H_H, grab: NONE },
    '2h': { light: MOVE_ID.W2H_1, heavy: MOVE_ID.W2H_H, grab: NONE },
    dual: { light: MOVE_ID.WD_1, heavy: MOVE_ID.WD_H, grab: NONE },
    staff: { light: MOVE_ID.WS_1, heavy: MOVE_ID.WS_H, grab: NONE },
  },
  air: {
    unarmed: { light: MOVE_ID.A1, heavy: MOVE_ID.A2, grab: NONE },
    '1h': { light: MOVE_ID.W1H_AX, heavy: MOVE_ID.W1H_AY, grab: NONE },
    '2h': { light: MOVE_ID.W2H_AX, heavy: NONE, grab: NONE },      // 2H / asa hava Y yok (DESIGN §2)
    dual: { light: MOVE_ID.WD_AX, heavy: MOVE_ID.WD_AY, grab: NONE },
    staff: { light: MOVE_ID.WS_AX, heavy: NONE, grab: NONE },
  },
  running: {
    unarmed: { light: MOVE_ID.D1, heavy: MOVE_ID.H1_RUN, grab: MOVE_ID.G1 },
    '1h': { light: MOVE_ID.W1H_RX, heavy: MOVE_ID.H1_RUN, grab: NONE },   // WR-Y = Kick → (ıska takibi) W1H_leap_smash
    '2h': { light: MOVE_ID.W2H_RX, heavy: MOVE_ID.W2H_RY, grab: NONE },
    dual: { light: MOVE_ID.WD_1, heavy: MOVE_ID.WD_H, grab: NONE },
    staff: { light: MOVE_ID.WS_H, heavy: MOVE_ID.WS_RY, grab: NONE },
  },
  carrying: {
    unarmed: { light: NONE, heavy: MOVE_ID.C_BASH, grab: NONE },   // B fırlat / L1 bırak grab.ts'de
    '1h': { light: NONE, heavy: NONE, grab: NONE }, '2h': { light: NONE, heavy: NONE, grab: NONE },
    dual: { light: NONE, heavy: NONE, grab: NONE }, staff: { light: NONE, heavy: NONE, grab: NONE },
  },
};
/** Iska takibi hedefinin silaha göre değişimi: koşu Kick'i (H1_kick_run) → D2, 1H ile → W1H_leap_smash (DESIGN §4.2 1H WR-Y). */
export const HOLD_BRANCH_BY_WEAPON: Readonly<Record<string, Partial<Record<WeaponKind, string>>>> = {
  [MOVE_ID.D2]: { '1h': MOVE_ID.W1H_RY },
};
